import type { FC } from 'react'
import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { Image } from '@/components/ui'
import { useLightboxPageContext } from '@/components/ui/Lightbox/constants'
import { useAddImageToLightboxOnload } from '@/components/ui/Lightbox/useAddImageToLightboxOnload'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { getMinioImagePath } from '@/utils/images'
import type { IPublicationComponentProps } from '../types'

const { image } = JOURNAL_TAG_ATTRIBUTES

export const PublicationImage: FC<IPublicationComponentProps> = props => {
  const { attribs } = props

  const { openLightbox } = useLightboxPageContext()

  const isAuthorQuote = attribs[image.main] === image.modifiers.authorQuote
  const isWithUrl = !!attribs[image.url]
  const imageSrc = attribs[image.src]
  const shouldOpenLightbox = (!isAuthorQuote || !isWithUrl) && imageSrc

  const onImageClick = () => {
    if (!shouldOpenLightbox) return
    openLightbox?.(imageSrc)
  }

  const isAddImageToLightbox = !isAuthorQuote && !isWithUrl && !!imageSrc

  useAddImageToLightboxOnload(isAddImageToLightbox ? { src: getMinioImagePath({ src: imageSrc }) } : undefined)

  if (attribs[image.label] !== undefined)
    return (
      <figure className={classNames('publicationText__imageWithCaption', isAuthorQuote && 'publicationText__authorQuote')}>
        <CommonLink
          shouldOpenInNewWindow
          url={attribs[image.url]}
          spanIfEmpty
          onClick={onImageClick}
          className={classNames(isAuthorQuote && 'publicationText__authorQuoteImageLink')}
        >
          <Image
            className={classNames(isAuthorQuote ? 'publicationText__authorQuoteImage' : 'publicationText__image', {
              'publicationText__image--galleryItem': !isWithUrl && !isAuthorQuote,
            })}
            src={attribs[image.src]}
            alt={isAuthorQuote ? attribs[image.label] : attribs[image.alt]}
          />
        </CommonLink>

        <figcaption
          className={classNames(
            isAuthorQuote
              ? 'publicationText__authorQuoteCaption font-weight_light-bold text_body text_small-sm'
              : 'publicationText__imageCaption text_small text_super-small-sm',
          )}
        >
          {isAuthorQuote && attribs[image.labelLink] ? <a href={attribs[image.labelLink]}>{attribs[image.label]}</a> : attribs[image.label]}
        </figcaption>
      </figure>
    )

  return (
    <CommonLink shouldOpenInNewWindow url={attribs[image.url]} spanIfEmpty onClick={onImageClick}>
      <Image
        className={classNames('publicationText__image', { 'publicationText__image--galleryItem': !isWithUrl && !isAuthorQuote })}
        src={attribs[image.src]}
        alt={isAuthorQuote ? attribs[image.label] : attribs[image.alt]}
      />
    </CommonLink>
  )
}
